var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceLists(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.526 10.789L23.947 10.789M5.526 18.684L16.053 18.684M5.526 26.579L12.105 26.579M12.105 34.474h-9.21c-1.454 0-2.632-1.179-2.632-2.632V2.895C.263 1.44 1.441.263 2.895.263h18.647c.698 0 1.366.277 1.86.77l5.038 5.039c.493.493.77 1.162.77 1.86v5.49",
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4) translate(18.947 18.947)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.526,
    cy: 10.526,
    r: 10.048
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.962 14.833c-2.775 0-4.306-1.532-4.306-4.307 0-2.775 1.53-4.306 4.306-4.306M6.22 9.091L9.987 9.091 10.431 9.091M6.22 11.962L10.431 11.962"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceLists);
export default __webpack_public_path__ + "static/media/price_lists.963e3916dd946d05e17ac6d2a5b6fefc.svg";
export { ForwardRef as ReactComponent };